import React, { useState, useEffect } from "react";
import { useSelector, connect } from 'react-redux';
import moment from "moment";
import * as XLSX from 'xlsx';
import Draggable from 'react-draggable';
import { Link } from 'react-router-dom'
import { ConsoleSqlOutlined, DownloadOutlined } from "@ant-design/icons";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContentText,
  DialogContent,
  TablePagination,
  TextField,
  Button,
  IconButton,
  Paper,
  Table,
  FormControl,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  Divider
} from "@material-ui/core";

import {
  Close,
  CheckCircle
} from "@material-ui/icons";

import CheckIcon from '@material-ui/icons/Check';
import EditIcon from '@material-ui/icons/Edit';

import Autocomplete from '@material-ui/lab/Autocomplete';
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import { ROLENAME } from '../utils/index';
import HttpService from "../services/httpService";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";

function PaperComponent(props) {
  return (
    <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 850,
  },
  tableHeader:{
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: "#2C2E3E"
  },
  tableCell: {
    fontWeight: "800",
    textAlign:"center",
    color: 'white',
    minWidth: '150px'
  },
  uploadButton: {
  backgroundColor: 'white',
  color: '#14419c',
  padding: '1',
  marginRight: '0.5em',
  marginLeft: '0.5em',
  marginBottom: '0.5em',
  borderRadius: '20px',
  "&:hover": { backgroundColor: "#14419c", color: 'white' }
},
  textField: {
    marginLeft: theme.spacing(5),
    marginRight: theme.spacing(5),
    width: 300
  },
  paper: {
    padding: "2rem 2rem 2rem 2rem",
    textAlign: "center",
    color: theme.palette.text.secondary
  },
  heading: {
    margin: 'auto',
    textAlign: "center",
    color: "white",
    backgroundColor: "#2C2E3E",
    padding: 10,
    borderRadius: 50,
    width: "50%",
    fontSize: 20,
    marginBottom: 20
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '20vh'
},
outBoundCallButton: {
  margin: theme.spacing(2),
  padding: theme.spacing(3, 6),
  fontSize: '1.5rem',
  borderWidth: '2px'
},
inputContainer: {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  marginTop: theme.spacing(4)
},
contactNoInput: {
  marginBottom: theme.spacing(2),
  width: '300px',
  fontSize: '1.2rem'
},
clickToCallButton: {
  padding: theme.spacing(1, 2),
  fontSize: '0.5rem'
},
tableContainerFixed: {
  position: 'fixed',        
  top: '6em',              
  right: '4em',            
  width: '12%',             
  height: '35%',             
  // maxHheight: '20vh',        
  overflowY: 'auto',        
  zIndex: 1000,             
  fontSize: '1em'      
},
tableCell: {
  padding: '4px',           
  textAlign: 'center',      
  color: 'white'
},
tableCellNew: {
  padding: '2px 2px',  
  fontSize: '10px',         
  textAlign: 'center'  
},
tableCellHead: { 
  fontSize: '10px',    
  textAlign: 'center',
  backgroundColor: '#2c2e3e',
  color: 'white'   ,
  padding: '2px 2px',  
},
tableContainerNormal: {
  marginTop: '200px',
  width: '100%'
},
yesButton: {
  backgroundColor: 'white',
  color: '#14419c',
  padding: '1',
  marginRight: '0.5em',
  marginLeft: '0.5em',
  borderRadius: '20px',
  "&:hover": { backgroundColor: "#14419c", color: 'white' }
},
dateField: {
  width: '30%',
  marginRight: '2%'
},

filterButton: {
  backgroundColor: '#bbcef2',
  color: 'black',
  padding: '1',
  marginRight: '0.5em',
  marginLeft: '0.5em',
  borderRadius: '20px',
  alignSelf: "center",
  "&:hover": { backgroundColor: "#3b527d", color: 'white' }
},
resetButton: {
  backgroundColor: '#fadcde',
  color: 'black',
  padding: '1',
  marginRight: '0.5em',
  borderRadius: '20px',
  alignSelf: "center",
  "&:hover": { backgroundColor: "#9c5c60", color: 'white' }
},
downloadCsvButton: {
  backgroundColor: '#a7f2af',
  color: 'black',
  padding: '1',
  borderRadius: '20px',
  alignSelf: "center",
  "&:hover": { backgroundColor: "#4d7850", color: 'white' } },

actionButton: {
  backgroundColor: '#f0f2f0',
  color: 'black',
  padding: '1',
  borderRadius: '20px',
  alignSelf: "center",
  "&:hover": { backgroundColor: "#7a7d7a", color: 'white' } },

screenTabs: {
  backgroundColor: 'white',
  color: 'black',
  padding: '1',
  marginTop: '0.5em',
  marginRight: '0.5em',
  marginLeft: '0.5em',
  borderRadius: '20px',
  "&:hover": { backgroundColor: "#2c2e3e", color: 'white' }
},
screenTabsDiv: {
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '1%',
  marginBottom: '1%'
}
}));



const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#ccc",
    color: theme.palette.common.black
  },
  body: {
    fontSize: 14
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: theme.palette.action.hover
    },
  },
}))(TableRow);

const CallCenterDashboard = (props) => {
  const { userDetails } = useSelector(state => state.user)
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCallLogsCount, setTotalCallLogsCount] = useState(0);
  const [endDate, setEndDate] = useState(null)
  const [startDate, setStartDate] = useState(null)
  const [nextFollowUpDate, setNextFollowUpDate] = useState(null)
  const [nextFollowUpTime, setNextFollowUpTime] = useState(null)
  const [showCallButton, setShowCallButton] = useState(false)
  const [isFileUploaded, setIsFileUploaded] = useState(false)
  const [showCallActions, setShowCallActions] = useState(false)
  const [showFollowUpDialog, setShowFollowUpDialog] = useState(false)
  const [showContactNoInput, setShowContactNoInput] = useState(false)
  const [showReAssignDialog, setShowReAssignDialog] = useState(false)
  const [showLeadApprovalDialog, setShowLeadApprovalDialog] = useState(false)
  const [showLeadDetailsDialog, setShowLeadDetailsDialog] = useState(false)
  const [showTicketDetailsDialog, setShowTicketDetailsDialog] = useState(false)
  const [showLeadEditDialog, setShowLeadEditDialog] = useState(false)
  const [showTicketApprovalDialog, setShowTicketApprovalDialog] = useState(false)
  const [showJunkLeadApprovalDialog, setShowJunkLeadApprovalDialog] = useState(false)
  // const [isEditing, setIsEditing] = useState(false);
  const [isEditing, setIsEditing] = useState({
    customer_name: false,
    customer_no: false,
    customer_email: false,
    customer_address: false,
    category: false,
    assigned_to: false,
    ticketTitle: false,
    ticketDescription: false,
  });
  const [isDisabled, setIsDisabled] = useState(false);
  const [fileUploaded, setFileUploaded] = useState(false);
  const [remarks, setRemarks] = useState('')
  const [callAction, setCallAction] = useState('')
  const [selectedTab, setSelectedTab] = useState('Action')
  const [currentContactNo, setCurrentContactNo] = useState('')
  const [junkLeadAttachment, setJunkLeadAttachment] = useState('')
  const [followUpDataCSV, setFollowUpDataCSV] = useState('')
  const [leadApprovalRemarks, setLeadApprovalRemarks] = useState('')
  const [dashboardClickedValue, setDashboardClickedValue] = useState('')
  const [ticketReAssignUserEmail, setTicketReAssignUserEmail] = useState('')
  const [currentCallDetails, setCurrentCallDetails] = useState({})
  const [currentLeadDetails, setCurrentLeadDetails] = useState({})
  const [currentTicketDetails, setCurrentTicketDetails] = useState({})
  const [selectedUserToReAssign, setSelectedUserToReAssign] = useState({})
  const [selectedTicketCategory, setSelectedTicketCategory] = useState({})
  const [reAssignUsers, setReAssignUsers] = useState([])
  const [ticketCategories, setTicketCategories] = useState([])
  const [usersInTeam, setUsersInTeam] = useState([])
  const [leadsForApproval, setLeadsForApproval] = useState([])
  const [followUpSelfData, setFollowUpSelfData] = useState([])
  const [ticketsForApproval, setTicketsForApproval] = useState([])
  const [callCenterJunkLeads, setCallCenterJunkLeads] = useState([])
  const [dashboardDetailedData, setDashboardDetailedData] = useState([])
  const [dashboardTableOneData, setDashboardTableOneData] = useState([])
  const [dashboardTableTwoData, setDashboardTableTwoData] = useState([])
  const [followUpMarketingData, setFollowUpMarketingData] = useState([])
  const [followUpSelfForTeamData, setFollowUpSelfForTeamData] = useState([])
  const [followUpMarketingForTeamData, setFollowUpMarketingForTeamData] = useState([])
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedCallDetails, setSelectedCallDetails] = useState({
    last_follow_up_date: null,
    last_remarks: '',
    source_of_lead: '',
    lead_date: null,
    last_call_date: null,
  });

  const handleDateChange = (e) => {
    setNextFollowUpDate(e.target.value);
  };

  const handleTimeChange = (e) => {
    setNextFollowUpTime(e.target.value);
  };

  const handle_filter_click = async () => {
    props.setLoading(true)
    try {
      let data = {}
      data.startDate = startDate
      data.endDate = endDate
      data.users = selectedUsers
      let result = await HttpService.getFilteredCallCenterDashboardData(data)
      setDashboardTableOneData([...result.data.dashboard_table_one_data])
      setDashboardTableTwoData([...result.data.dashboard_table_two_data])
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
    props.setLoading(false)
  }

  const handle_tab_selection = async (input) => {
    props.setLoading(true)
    try {
      if (input == 'Action') {
        // will handle later
      } else if(input == 'Dashboard') {
        let result = await HttpService.getCallCenterDashboardData()
        setDashboardTableOneData([...result.data.dashboard_table_one_data])
        setDashboardTableTwoData([...result.data.dashboard_table_two_data])
      } else if(input == 'FollowUpSelf') {
        const result = await HttpService.getFollowUpSelfData()
        setFollowUpSelfData(result.data)
      } else if(input == 'FollowUpMarketing') {

      } else if(input == 'Testing') {
        // will handle later
      } else if(input == 'FollowUpSelfForTeam') {
        const result = await HttpService.getFollowUpSelfForTeamData()
        setFollowUpSelfForTeamData(result.data)
      } else if(input == 'FollowUpMarketingForTeam') {
        // will handle later
      } else if(input == 'Junk') {
        const result = await HttpService.getCallCenterJunkLeads()
        setCallCenterJunkLeads(result.data)
      } else if(input == 'ApprovalRequests') {
        const result = await HttpService.get_pending_approval_for_cc_am()
        setLeadsForApproval(result.data.LeadsData)
        setTicketsForApproval(result.data.TicketsData)
      }
      if(input !== 'Dashboard') {
        setSelectedTab(input)
      }
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
    props.setLoading(false)
  }

  const handle_call_action = async (input) => {
    try {
      setCallAction(input)
      setShowFollowUpDialog(true)
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
  }

  const handle_call_action_submit = async () => {
    props.setLoading(true)
    try {
      let data = {}
      data.customer_no = currentContactNo
      data.call_type = 'outgoing'
      data.remarks = remarks
      if(callAction == 'moveToJunk') {
        data.call_status = 'junk'
        data.junkLeadAttachment = junkLeadAttachment
      } else if(callAction == 'moveToFollowUp') {
         data.call_status = 'follow_up_self'
         data.next_follow_up_date = new Date(`${nextFollowUpDate}T${nextFollowUpTime}:00`)
      }
      let result = await HttpService.updateCallCenterLead(data)
      setShowFollowUpDialog(false)
      setShowCallActions(false)
      setNextFollowUpDate(null)
      setNextFollowUpTime(null)
      setCurrentContactNo('')
      setRemarks('')
      setIsFileUploaded(false)
      setJunkLeadAttachment('')
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
    props.setLoading(false)
  }

  const handle_remarks = async (e,v) => {
    try {
      setRemarks(e.target.value)
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
  }

  const handle_lead_approval_remarks = async (e,v) => {
    try {
      setLeadApprovalRemarks(e.target.value)
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
  }
  

  const handle_close_call_actions_dialog = async () => {
    try {
      setShowCallActions(false)
      setShowFollowUpDialog(false)
      setCurrentCallDetails({})
      setCallAction('')
      setRemarks('')
      setIsFileUploaded(false)
      setJunkLeadAttachment('')
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
  }

  const handle_close_call_reAssign_dialog = async () => {
    try {
      setShowReAssignDialog(false)
      setReAssignUsers([])
      setSelectedUserToReAssign({})
      setCallAction('')
      setRemarks('')
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
  }

  const handle_close_lead_approval_dialog = async () => {
    try {
      setShowLeadApprovalDialog(false)
      setLeadApprovalRemarks('')
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
  }

  const handle_close_lead_edit_dialog = async () => {
    try {
      setShowLeadDetailsDialog(false)
      setIsEditing({
        customer_name: false,
        customer_no: false,
        customer_email: false,
        customer_address: false,
        category: false,
        assigned_to: false,
        ticketTitle: false,
        ticketDescription: false,
      })
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
  }

  const handle_close_ticket_edit_dialog = async () => {
    try {
      setShowTicketDetailsDialog(false)
      setIsEditing({
        customer_name: false,
        customer_no: false,
        customer_email: false,
        customer_address: false,
        category: false,
        assigned_to: false,
        ticketTitle: false,
        ticketDescription: false,
      })

    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
  }

  const handle_close_junk_lead_approval_dialog = async () => {
    try {
      setShowJunkLeadApprovalDialog(false)
      setRemarks('')
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
  }

  const handle_close_ticket_approval_dialog = async () => {
    try {
      setShowTicketApprovalDialog(false)
      setRemarks('')
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
  }
  
  const handle_clear_filter = async () => {
    props.setLoading(true)
    try {
      setStartDate('')
      setEndDate('')
      setSelectedUsers([])
      let result = await HttpService.getCallCenterDashboardData()
      setDashboardTableOneData([...result.data.dashboard_table_one_data])
      setDashboardTableTwoData([...result.data.dashboard_table_two_data])
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
    props.setLoading(false)
  }
  
  const handle_change_page_click = (event, newPage) => {
    setPage(newPage);
    handle_filter_click({newPage: newPage})
  };

  const handle_change_rows_per_page_click = (event) => {
      setRowsPerPage(Number(event.target.value));
      setPage(0);
      handle_filter_click({newRowsPerPage: Number(event.target.value)})
  };

  const handle_send_to_manager = async () => {
    props.setLoading(true)
    try {
      let result = await HttpService.sendCallCenterLeadToManager({remarks: remarks, customer_no: currentContactNo})
      const result2 = await HttpService.getFollowUpSelfData()
      setFollowUpSelfData(result2.data)
      setShowFollowUpDialog(false)
      props.setSnackInfo(`Moved to Assistant Manager successfully!`, 'success')
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
    props.setLoading(false)
  }

  const handle_call_click = async (input) => {
    try {
      setCurrentContactNo(input.client_phone_number)
      let data = {}
      data.agent_number = userDetails.mobile
      data.customer_number = input.client_phone_number
      props.setLoading(true)
      let callDetails = await HttpService.getCallDetails({client_phone_number: input.client_phone_number})
      setSelectedCallDetails({
        ...selectedCallDetails,
        last_remarks: input.last_remarks || 'NA',
        last_follow_up_date: input.last_follow_up_date || null,
        last_call_date: callDetails.data.last_call_activity || null,
        source_of_lead: callDetails.data.source_of_lead || 'NA',
        lead_date: callDetails.data.lead_date || null,
      })
      let result = await HttpService.makeCall(data)
      props.setLoading(false)
      setCurrentCallDetails(input)
      setShowCallActions(true)
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
  }

  const handleOutBoundCallButtonClick = async () => {
    setShowContactNoInput(true)   
    setCurrentContactNo('') 
  }

  const handleReceiveCallButtonClick = async () => {
    props.setSnackInfo(`handleReceiveCallButtonClick function called`, 'success')
    setShowContactNoInput(false) 
    setCurrentContactNo('')
  }

  const handleContactNo = (e,v) => {
      let {name, value} = e.target
      setCurrentContactNo(value)
  }

  const handle_re_assign_click = async (input) => {
    props.setLoading(true)
    try {
      setCurrentCallDetails(input)
      const result = await HttpService.getCallCenterUsersForAM()
      setReAssignUsers(result.data)
      setShowReAssignDialog(true)
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
    props.setLoading(false)
  }

  const handle_approve_junk_click = async (input) => {
      setCurrentCallDetails(input)
      setShowJunkLeadApprovalDialog(true)
  }

  const handle_approve_junk_lead_submit = async () => {
    props.setLoading(true)
    try {
      let data = {...currentCallDetails, remarks: remarks}
      const result = await HttpService.approve_call_center_junk_lead(data)
      // console.log('result', result.data)
      const result2 = await HttpService.getCallCenterJunkLeads()
      // console.log('result2', result2)
      setCallCenterJunkLeads(result2.data)
      setShowJunkLeadApprovalDialog(false)
      setCurrentCallDetails({})
      setRemarks('')
      props.setSnackInfo(`${result.data}`, 'success')
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
    props.setLoading(false)
  }

  const handle_verify_ticket_submit = async () => {
    props.setLoading(true)
    try {
      let category_id = selectedTicketCategory._id
      let updateTicketObj = {...currentTicketDetails, category_id}
      // const response = await HttpService.updateTicketDetails(currentTicketDetails)
      const response = await HttpService.updateTicketDetails(updateTicketObj)
      let data = {...currentTicketDetails, ticketReAssignUserEmail, remarks, }
      const result = await HttpService.verify_call_center_ticket(data)
      // console.log('result', result.data)

      const result2 = await HttpService.get_pending_approval_for_cc_am()
      // console.log('result2', result2)
      setLeadsForApproval(result2.data.LeadsData)
      setTicketsForApproval(result2.data.TicketsData)
      setShowTicketApprovalDialog(false)
      setShowTicketDetailsDialog(false)
      setCurrentTicketDetails({})
      setRemarks('')
      setTicketReAssignUserEmail('')
      setIsEditing({
        customer_name: false,
        customer_no: false,
        customer_email: false,
        customer_address: false,
        category: false,
        assigned_to: false,
        ticketTitle: false,
        ticketDescription: false,
      })

      props.setSnackInfo(`${result.data}`, result.status == 200 ? 'success' : 'error')
    } catch(error) {
      props.setSnackInfo(`User Not Found or Something went wrong!`, 'error')
      setShowTicketApprovalDialog(false)
      setShowTicketDetailsDialog(false)
      setCurrentTicketDetails({})
      setRemarks('')
      setTicketReAssignUserEmail('')
      setIsEditing({
        customer_name: false,
        customer_no: false,
        customer_email: false,
        customer_address: false,
        category: false,
        assigned_to: false,
        ticketTitle: false,
        ticketDescription: false,
      })
      handle_tab_selection('ApprovalRequests')
      console.log('error: ', error.message)
      console.error(error)
    }
    props.setLoading(false)
  }

  const handle_user_selection = (e) => {
    // console.log('name', e.target.name)
    // console.log('value', e.target.value)
    setSelectedUserToReAssign(e.target.value)
  };

  const handle_ticket_category_selection = (e) => {
    setSelectedTicketCategory(e.target.value)
  };


  const handle_re_assign_user_submit_click = async (e) => {
    props.setLoading(true)
    try {
      // console.log('handle_re_assign_user_submit_click function called')
      // console.log('remarks', remarks)
      // console.log('userToReAssign', selectedUserToReAssign)
      let data = {}
      data.userToReAssign = selectedUserToReAssign
      data.callCenterLeadId = currentCallDetails._id
      data.clientPhontNumber = currentCallDetails.client_phone_number
      data.remarks = remarks
      const result = await HttpService.ReAssignCallCenterUser(data)
      setShowReAssignDialog(false)
      setRemarks('')
      setSelectedUserToReAssign({})
      const result2 = await HttpService.getFollowUpSelfForTeamData()
      // console.log('result2', result2.data)
      setFollowUpSelfForTeamData(result2.data)
      const result3 = await HttpService.getCallCenterJunkLeads()
      // console.log('result3', result3.data)
      setCallCenterJunkLeads(result3.data)
      props.setSnackInfo(`${result.data}`, 'success')
    } catch(error) {
      console.log('error: ', error.message)
      console.error(error)
    }
    props.setLoading(false)
  };

  const handle_verify_lead_approval = async () => {
    props.setLoading(true)
    try {
      const response = await HttpService.updateLeadDetails(currentLeadDetails)
      // console.log('handle_verify_lead_approval function called')
      // console.log('remarks', leadApprovalRemarks)
      // console.log('currentLeadDetails', currentLeadDetails)
      let payload = {}
      payload.lead_id = currentLeadDetails._id
      payload.customer_no = currentLeadDetails.customer_no
      payload.leadApprovalRemarks = leadApprovalRemarks
      // console.log('payload', payload)
      const result = await HttpService.verifyLead(payload)
      setShowLeadApprovalDialog(false)
      setShowLeadDetailsDialog(false)
      setLeadApprovalRemarks('')
      setIsEditing({
        customer_name: false,
        customer_no: false,
        customer_email: false,
        customer_address: false,
        category: false,
        assigned_to: false,
        ticketTitle: false,
        ticketDescription: false,
      })
      const result2 = await HttpService.get_pending_approval_for_cc_am()
      // console.log('result2', result2.data)
      setLeadsForApproval(result2.data.LeadsData)
      props.setSnackInfo(`Lead verified successfully!`, 'success')
    } catch(error) {
        console.log('error: ', error.message)
        console.error(error)
    }
    props.setLoading(false)
  };

  const handle_verify_lead = async (input) => {
    try {
      setCurrentLeadDetails(input)
      setShowLeadDetailsDialog(true)
      // setShowLeadApprovalDialog(true)
    } catch(error) {
      console.log('error: ', error)
      console.error(error)
    }
  }

  const handle_edit_lead = async () => {
    try {
      props.setLoading(true)
      // console.log('sending request to backend')
      const response = await HttpService.updateLeadDetails(currentLeadDetails)
      // console.log('request received from backend')
      // console.log('response: ', response.data)
      props.setSnackInfo(response.data, "success");
      handle_tab_selection('ApprovalRequests')
      setShowLeadDetailsDialog(false)
      props.setLoading(false)
    } catch(error) {
      console.log('error: ', error)
      console.error(error)
    }
  }

  const handle_edit_ticket = async () => {
    try {
      // return null
      props.setLoading(true)
      // console.log('sending request to backend')
      const response = await HttpService.updateTicketDetails(currentTicketDetails)
      // console.log('request received from backend')
      // console.log('response: ', response.data)
      props.setSnackInfo(response.data, "success");
      handle_tab_selection('ApprovalRequests')
      setShowTicketDetailsDialog(false)
      props.setLoading(false)
    } catch(error) {
      console.log('error: ', error)
      console.error(error)
    }
  }

  const handle_verify_and_reassign_ticket = async (input) => {
    try {
      const result = await HttpService.getAllCHMticketCategory()
      setTicketCategories(result.data)
      let intial_category = result.data.find(category => category.value == input.category)
      setSelectedTicketCategory(intial_category)
      // return null
      // console.log('handle_verify_and_reassign_ticket function called, input: ', input)
      setCurrentTicketDetails(input)
      setShowTicketDetailsDialog(true)
    } catch(error) {
      console.log('error: ', error)
      console.error(error)
    }
  }

  const handleCellClick = async (input) => {
    // console.log('input type: ', input.type)
    // console.log('handleCellClick function called, input: ', input)
    // setDashboardClickedValue(input.title)
    setDashboardClickedValue(input.key)
    setDashboardDetailedData(input.data)
  }

  const onImageChange = async (e) => {
    props.setLoading(true);
    const fd = new FormData();
    fd.append('file', e.target.files[0]);
    try {
      const fileUploadRes = await HttpService.uploadFile(fd);
      if(e.target.name == 'followUpData') {
        setFollowUpDataCSV(fileUploadRes.data)
        const response = await HttpService.pushFollowUpData({link: fileUploadRes.data})
        if(response.status == 201) {
          props.setSnackInfo(`${response.data.error}. ${response.data.invalidEmails}`, "success");
        } else {
          props.setSnackInfo(response.data, "success");
          handle_tab_selection('FollowUpSelfForTeam')
        }
      } else {
        setIsFileUploaded(true)
        setJunkLeadAttachment(fileUploadRes.data)
      }
    } catch (err) {
      props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error");
    }
    props.setLoading(false);
  };

  const handle_download_csv_click = async () => {
    props.setLoading(true)
    try {
      // console.log('handle_download_csv_click function called')
      // console.log('dashboardTableOneData', dashboardTableOneData)
      // console.log('dashboardTableTwoData', dashboardTableTwoData)
      
      let dashboardTables = [...dashboardTableOneData, ...dashboardTableTwoData]
      
      // console.log('dashboardTables', dashboardTables)
      
      
      const wb = XLSX.utils.book_new();
      
      // let data = dashboardTables.find(table => table.key == 'TotalLeadsCreated').data
      
      // console.log('data', data)
      
      let TotalLeadsCreated = dashboardTables.find(table => table.key == 'TotalLeadsCreated')?.data, TotalLeadsCreatedCSV = []
      let TotalTicketsCreated = dashboardTables.find(table => table.key == 'TotalTicketsCreated')?.data, TotalTicketsCreatedCSV = []
      let CallsMovedToJunk = dashboardTables.find(table => table.key == 'CallsMovedToJunk')?.data, CallsMovedToJunkCSV = []
      let CallsMovedToFollowUpSelf = dashboardTables.find(table => table.key == 'CallsMovedToFollowUpSelf')?.data, CallsMovedToFollowUpSelfCSV = []
      let TotalIncomingCalls = dashboardTables.find(table => table.key == 'TotalIncomingCalls')?.data, TotalIncomingCallsCSV = []
      let TotalOutgoingCalls = dashboardTables.find(table => table.key == 'TotalOutgoingCalls')?.data, TotalOutgoingCallsCSV = []
      let TotalConnectedCalls = dashboardTables.find(table => table.key == 'TotalConnectedCalls')?.data, TotalConnectedCallsCSV = []
      let TotalMissedCalls = dashboardTables.find(table => table.key == 'TotalMissedCalls')?.data, TotalMissedCallsCSV = []
      
      // console.log('TotalLeadsCreated', TotalLeadsCreated)
      
      for(let i = 0; i < TotalLeadsCreated?.length; i++) {
        let obj = {}
        obj['Sl. No'] = i+1
        obj['Lead No'] = TotalLeadsCreated[i]['lead_no']
        obj['Client Name'] = TotalLeadsCreated[i]['customerId'].name
        // obj['Client Contact No'] = TotalLeadsCreated[i]['customerId'].contact_no
        obj['Unique Lead No'] = TotalLeadsCreated[i]['uniqueLeadNumber']
        obj['Lead Created By'] = TotalLeadsCreated[i]['createdBy'].name
        obj['Call Date'] = moment(TotalLeadsCreated[i]['call_date']).format('DD-MM-YYYY')
        obj['Call Time'] = TotalLeadsCreated[i]['call_time']
        obj['Call Duration'] = TotalLeadsCreated[i]['call_duration']
        obj['Call Recording'] = TotalLeadsCreated[i]['recording_url']
        
        TotalLeadsCreatedCSV.push(obj)
      }

      // console.log('TotalTicketsCreated', TotalTicketsCreated)

      for(let i = 0; i < TotalTicketsCreated?.length; i++) {
        let obj = {}
        obj['Sl. No'] = i+1
        obj['Unique Ticket No'] = TotalTicketsCreated[i]['uniqueTicketNo']
        obj['Lead No'] = TotalTicketsCreated[i]['leadNumber']
        obj['Unique Lead No'] = TotalTicketsCreated[i]['uniqueLeadNumber']
        obj['Client Name'] = TotalTicketsCreated[i]['customerId'].name
        // obj['Client Contact No'] = TotalTicketsCreated[i]['customerId'].contact_no
        obj['Created By'] = TotalTicketsCreated[i]['ticketCreatedBy'].name
        obj['Call Date'] = moment(TotalTicketsCreated[i]['call_date']).format('DD-MM-YYYY')
        obj['Call Time'] = TotalTicketsCreated[i]['call_time']
        obj['Call Duration'] = TotalTicketsCreated[i]['call_duration']
        obj['Call Recording'] = TotalTicketsCreated[i]['recording_url']
        
        TotalTicketsCreatedCSV.push(obj)
      }
      
      
      
      const ws1 = XLSX.utils.json_to_sheet(TotalTicketsCreatedCSV);
      const ws2 = XLSX.utils.json_to_sheet(TotalTicketsCreatedCSV);
      // const ws3 = XLSX.utils.json_to_sheet(CallsMovedToJunkCSV);
      // const ws4 = XLSX.utils.json_to_sheet(CallsMovedToFollowUpSelfCSV);
      // const ws5 = XLSX.utils.json_to_sheet(TotalIncomingCallsCSV);
      // const ws6 = XLSX.utils.json_to_sheet(TotalOutgoingCallsCSV);
      // const ws7 = XLSX.utils.json_to_sheet(TotalConnectedCallsCSV);
      // const ws8 = XLSX.utils.json_to_sheet(TotalMissedCallsCSV);

      XLSX.utils.book_append_sheet(wb, ws1, 'Total Leads Created');
      XLSX.utils.book_append_sheet(wb, ws2, 'Total Tickets Created');
      // XLSX.utils.book_append_sheet(wb, ws3, 'Calls Moved To Junk');
      // XLSX.utils.book_append_sheet(wb, ws4, 'Calls Moved To FollowUpSelf');
      // XLSX.utils.book_append_sheet(wb, ws5, 'Total Incoming Calls');
      // XLSX.utils.book_append_sheet(wb, ws6, 'Total Outgoing Calls');
      // XLSX.utils.book_append_sheet(wb, ws7, 'Total Connected Calls');
      // XLSX.utils.book_append_sheet(wb, ws8, 'Total Missed Calls');
      
      XLSX.writeFile(wb, 'call-center-dashboard.xlsx');
    }
    catch(error)
    {
      console.log('error', error.message)
      console.error(error)
    }
    props.setLoading(false)
  }

  const handleChangeUsers = (event, newValue) => {
    setSelectedUsers(newValue);
}

const get_usersInTeam = async () => {
  try {
    const usersInTeam = await HttpService.getCallCenterUsersForAM()
    // console.log('usersInTeam', usersInTeam)
    setUsersInTeam(usersInTeam.data)
  } catch(error) {
    console.log('error', error.message)
    console.error(error)
  }
}

const handle_Lead_details_change = (e) => {
  try {
    // console.log('name: ', e.target.name)
    // console.log('value: ', e.target.value)
    let temp_details = {...currentLeadDetails}
    temp_details[e.target.name] = e.target.value
    setCurrentLeadDetails(temp_details)

  } catch(error) {
    console.log('error: ', error.message)
    console.error(error)
  }
}

const handle_Ticket_details_change = (e) => {
  try {
    // console.log('name: ', e.target.name)
    // console.log('value: ', e.target.value)
    let temp_details = {...currentTicketDetails}
    temp_details[e.target.name] = e.target.value
    setCurrentTicketDetails(temp_details)

  } catch(error) {
    console.log('error: ', error.message)
    console.error(error)
  }
}
  

const toggleEdit = (value) => {
  if (!isDisabled) {
    // setIsEditing(!isEditing);
    let tempData = {...isEditing}
    tempData[value] = !tempData[value]
    setIsEditing(tempData);
  }
};

  useEffect(() => {
    handle_tab_selection('Dashboard')
    if(userDetails?.roles?.find(role => role.name === ROLENAME.TeleCallerUser)) {
      handle_tab_selection('FollowUpSelf')
    } else {
      handle_tab_selection('FollowUpSelfForTeam')
      get_usersInTeam()
    }
  },[]);

  return (
    <div style={{width: '80%', marginTop: -20}}>
      <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '1%', marginBottom: '1%' }}>
        <TextField
            id="date"
            name="startDate"
            label="From Date"
            type="date"
            variant="outlined"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{
                shrink: true,
            }}
            fullWidth
            className={classes.dateField}
            // style={{marginRight: '2%', marginLeft: '2%' }}
            size="small"
        />
        <TextField
            id="date"
            name="endDate"
            label="Till Date"
            type="date"
            variant="outlined"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{
                shrink: true,
            }}
            fullWidth
            className={classes.dateField}
            // style={{ width: '30%', marginRight: '2%', marginLeft: '2%' }}
            size="small"
        />
        {
          userDetails?.roles?.find(
          role =>
            role.name === ROLENAME.TeleCallerAssistantManager
          ) &&
          <Autocomplete
          multiple
          value={selectedUsers}
          onChange={handleChangeUsers}
          options={usersInTeam}
          getOptionLabel={(option) => option.name}
          style={{ width: '30%'}}
          size="small"
          renderInput={(params) => (
            <TextField
              {...params}
              label='Search User'
              variant='outlined'
            />
          )}
        />
      }
        <Button disabled={false} className={classes.filterButton} variant="outlined" onClick={handle_filter_click} >
              Filter
        </Button>
        <Button className={classes.resetButton} variant="outlined" onClick={()=>handle_clear_filter()} >
              Reset
        </Button>
        <Button disabled={false} className={classes.downloadCsvButton} variant="outlined" onClick={handle_download_csv_click} >
          CSV
        </Button>
        </div>
      {userDetails?.roles?.find(
          role =>
            role.name === ROLENAME.TeleCallerAssistantManager
          ) &&
          <FormControl fullWidth>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <TextField
              accept="*"
              id="contained-button-file"
              type="file"
              name='followUpData'
              onChange={onImageChange}
              style={{ display: 'none' }}
            />
            <label htmlFor="contained-button-file" style={{ display: 'flex', alignItems: 'flex-end', marginLeft: 10 }}>
              <Button variant="contained" color="primary" component="span">
                Upload Data
              </Button>
              {isFileUploaded && (
                <CheckCircle style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />
              )}
            </label>
          </div>
          </FormControl>}

      {
         userDetails?.roles?.find(
          role =>
            role.name === ROLENAME.MarketingManager ||
            role.name === ROLENAME.MarketingUser
          ) &&
          <></>
      }

      {
         userDetails?.roles?.find(
          role =>
            role.name === ROLENAME.TeleCallerUser
          ) &&
          <>
            <div className={classes.screenTabsDiv}>
              {/* <Button disabled={false} className={classes.screenTabs} variant="outlined" onClick={() => handle_tab_selection('Action')} >
                    Action
              </Button> */}
              {/* <Button className={classes.screenTabs} variant="outlined" onClick={()=>handle_tab_selection('FollowUpSelf')} >
                    Follow-Up
              </Button> */}
              {/* <Button className={classes.screenTabs} variant="outlined" onClick={()=>handle_tab_selection('FollowUpMarketing')} >
                    Follow-Up (Marketing)
              </Button> */}
            </div>

            {/* {
              selectedTab == 'Action' &&
              <>
                <div className={classes.buttonContainer}>
                  <Button className={classes.outBoundCallButton} onClick={handleOutBoundCallButtonClick} variant="outlined">
                      Outbound Call
                  </Button>
                  <Button className={classes.outBoundCallButton} onClick={handleReceiveCallButtonClick} variant="outlined">
                      Receive Call
                  </Button>
              </div>
                <br />
                <br />
                {
                  showContactNoInput &&
                  <div className={classes.inputContainer}>
                    <TextField
                        id="contact_no"
                        name="contact_no"
                        type="number"
                        variant="outlined"
                        placeholder="Contact No."
                        onChange={(e, v) => handleContactNo(e, v)}
                        value={currentContactNo}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        className={classes.contactNoInput}
                    />
                    <Button 
                        disabled={!currentContactNo.length} 
                        className={classes.clickToCallButton} 
                        onClick={() => handle_call_click({client_phone_number: currentContactNo})} 
                        variant="outlined">
                        Click To Call
                    </Button>
                  </div>
                }
              </>
            } */}

            {
              selectedTab == 'Dashboard' &&
              <>
                
              </>
            }

            {
              selectedTab == 'FollowUpSelf' &&
              <>
                <TableContainer component={Paper}>
                  <Table className="table table-responsive table-bordered" aria-label="sticky table">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell className={classes.tableCell}>S.No</StyledTableCell>
                        <StyledTableCell className={classes.tableCell}>Client Phone Number</StyledTableCell>
                        <StyledTableCell className={classes.tableCell}>Last Call Activity</StyledTableCell>
                        <StyledTableCell className={classes.tableCell}>Follow-Up Counts</StyledTableCell>
                        <StyledTableCell className={classes.tableCell}>Last Remarks</StyledTableCell>
                        <StyledTableCell className={classes.tableCell}>Action</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {followUpSelfData.map((row, i) => {
                        return (
                          <StyledTableRow key={i + 1}>
                            <StyledTableCell style={{textAlign:"center" }}>{i + 1}</StyledTableCell>
                            <StyledTableCell style={{textAlign:"center" }}>{row.client_phone_number ? row.client_phone_number : 'NA'}</StyledTableCell>
                            <StyledTableCell style={{textAlign:"center" }}>{row.last_call_activity ?  moment(row.last_call_activity).format('DD-MM-YYYY HH:mm') : 'NA'}</StyledTableCell>
                            <StyledTableCell style={{textAlign:"center" }}>{row.follow_up_count ? row.follow_up_count : 'NA'}</StyledTableCell>
                            <StyledTableCell style={{textAlign:"center" }}>{row.last_remarks ? row.last_remarks : 'NA'}</StyledTableCell>
                            <StyledTableCell style={{textAlign:"center" }}>
                              <Button disabled={false} className={classes.actionButton} variant="outlined" onClick={() => handle_call_click(row)} >
                                Call
                              </Button>
                            </StyledTableCell>

                          </StyledTableRow>
                        );
                      })}
                    </TableBody>
                  </Table>  
                </TableContainer>
              </>
            }

            {
              selectedTab == 'FollowUpMarketing' &&
              <>
                <TableContainer component={Paper}>
                  <Table className="table table-responsive table-bordered" aria-label="sticky table">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell className={classes.tableCell}>S.No</StyledTableCell>
                        <StyledTableCell className={classes.tableCell}>Client Phone Number</StyledTableCell>
                        <StyledTableCell className={classes.tableCell}>Last Call Activity</StyledTableCell>
                        <StyledTableCell className={classes.tableCell}>Follow-Up Counts</StyledTableCell>
                        <StyledTableCell className={classes.tableCell}>Last Remarks</StyledTableCell>
                        <StyledTableCell className={classes.tableCell}>Action</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {followUpMarketingData.map((row, i) => {
                        return (
                          <StyledTableRow key={i + 1}>
                            <StyledTableCell style={{textAlign:"center" }}>{i + 1}</StyledTableCell>
                            <StyledTableCell style={{textAlign:"center" }}>{row.client_phone_number ? row.client_phone_number : 'NA'}</StyledTableCell>
                            <StyledTableCell style={{textAlign:"center" }}>{row.last_call_activity ? moment(row.last_call_activity).format('DD-MM-YYYY HH:mm') : 'NA'}</StyledTableCell>
                            <StyledTableCell style={{textAlign:"center" }}>{row.follow_up_count ? row.follow_up_count : 'NA'}</StyledTableCell>
                            <StyledTableCell style={{textAlign:"center" }}>{row.last_remarks ? row.last_remarks : 'NA'}</StyledTableCell>
                            <StyledTableCell style={{textAlign:"center" }}>
                              <Button disabled={false} className={classes.actionButton} variant="outlined" onClick={() => handle_call_click(row)} >
                                Call
                              </Button>
                            </StyledTableCell>
                          </StyledTableRow>
                        );
                      })}
                    </TableBody>
                  </Table>  
                </TableContainer>
              </>
            }

            <Dialog
              open={showCallActions}
              // fullWidth
              maxWidth="md"
              PaperComponent={PaperComponent}
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
            >
              <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px' }}>
                <IconButton onClick={() => handle_close_call_actions_dialog()} size="small">
                  <Close />
                </IconButton>
              </div>
              <DialogTitle id="form-dialog-title" style={{ margin: "auto" }}>
                Status : Call has been placed successfully
              </DialogTitle>
              <DialogActions>
                <Button className={classes.actionButton} onClick={null} variant="outlined">
                  <Link to='/create-new-lead' target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'none', textAlign: 'center' }}>Create Lead</Link>
                </Button>
                <Button className={classes.actionButton} onClick={null} variant="outlined">
                  <Link to='/CHM-Ticket-Creation' target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'none', textAlign: 'center' }}>Create Ticket</Link>
                </Button>
                <Button className={classes.actionButton} onClick={() => handle_call_action('moveToFollowUp')} variant="outlined">
                  Move To Follow-Up
                </Button>
                <Button className={classes.actionButton} onClick={() => handle_call_action('moveToJunk')} variant="outlined">
                  Move To Junk
                </Button>
                <Button className={classes.actionButton} onClick={null} variant="outlined">
                  <Link to='/faq-details' target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'none', textAlign: 'center' }}>FAQ</Link>
                </Button>
              </DialogActions>

            </Dialog>

            <Dialog
              open={showFollowUpDialog}
              fullWidth
              PaperComponent={PaperComponent}
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
            >
              <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px' }}>
                <IconButton onClick={() => handle_close_call_actions_dialog()} size="small">
                  <Close />
                </IconButton>
              </div>
              <DialogTitle id="form-dialog-title" style={{ margin: "auto" }}>
              </DialogTitle>
                  {callAction == 'moveToFollowUp' &&
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: '10px' }}>
                    <TableContainer style={{width: '90%', marginBottom: '2%'}} component={Paper}>
                      <Table className="table table-responsive table-bordered" aria-label="sticky table">
                        <TableHead>
                          <StyledTableRow>
                            <StyledTableCell className={classes.tableCell}>Last Follow Up Date & Time</StyledTableCell>
                            <StyledTableCell className={classes.tableCell}>Last Remarks</StyledTableCell>
                            <StyledTableCell className={classes.tableCell}>Source of Lead</StyledTableCell>
                            <StyledTableCell className={classes.tableCell}>Lead Date & Time</StyledTableCell>
                            <StyledTableCell className={classes.tableCell}>Last Call Date & Time</StyledTableCell>
                          </StyledTableRow>
                        </TableHead>
                        <TableBody>
                          <StyledTableRow key={1}>
                            <StyledTableCell style={{textAlign:"center" }}>{selectedCallDetails.last_follow_up_date ? moment(selectedCallDetails.last_follow_up_date).format('DD-MM-YYYY HH:mm') : 'NA'}</StyledTableCell>
                            <StyledTableCell style={{textAlign:"center" }}>{selectedCallDetails.last_remarks ? selectedCallDetails.last_remarks : 'NA'}</StyledTableCell>
                            <StyledTableCell style={{textAlign:"center" }}>{selectedCallDetails.source_of_lead ? selectedCallDetails.source_of_lead : 'NA'}</StyledTableCell>
                            <StyledTableCell style={{textAlign:"center" }}>{selectedCallDetails.lead_date ? moment(selectedCallDetails.lead_date).format('DD-MM-YYYY HH:mm') : 'NA'}</StyledTableCell>
                            <StyledTableCell style={{textAlign:"center" }}>{selectedCallDetails.last_call_date ? moment(selectedCallDetails.last_call_date).format('DD-MM-YYYY HH:mm') : 'NA'}</StyledTableCell>
                          </StyledTableRow>
                        </TableBody>
                      </Table>  
                    </TableContainer>
                    <TextField
                    id="next_follow_up_date"
                    label="Next Follow-Up Date"
                    type="date"
                    value={nextFollowUpDate}
                    onChange={handleDateChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    style={{ width: '200px' }}
                    />
                    <TextField
                      id="next_follow_up_time"
                      label="Next Follow-Up Time"
                      type="time"
                      value={nextFollowUpTime}
                      onChange={handleTimeChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      style={{ width: '200px' }}
                    />
                  </div>
                  }
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: '10px', marginTop: '2%' }}>
                  <TextField
                    id="remarks"
                    name="remarks"
                    type="text"
                    variant="outlined"
                    placeholder="Remarks"
                    onChange={(e, v) => handle_remarks(e, v)}
                    value={remarks}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    // className={classes.ref_id_from_bank_field}
                    style={{ width: '400px' }}
                  />
                  {
                    callAction == 'moveToJunk' &&
                    <div>
                      <FormControl fullWidth margin="normal">
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                            <TextField
                              accept="*"
                              id="contained-button-file"
                              type="file"
                              onChange={onImageChange}
                              style={{ display: 'none' }}
                            />
                            <label htmlFor="contained-button-file" style={{ display: 'flex', alignItems: 'center', marginLeft: 10 }}>
                              <Button className={classes.yesButton} variant="outlined" component="span">
                                Upload File
                              </Button>
                              {isFileUploaded && (
                                <CheckCircle style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />
                              )}
                            </label>
                          </div>
                        </FormControl>
                    </div>
                  }
                </div>
                
              <DialogActions>
                {
                  callAction != 'sentToManager' &&
                  <Button disabled={!remarks || (callAction == 'moveToFollowUp' && (!nextFollowUpDate || !nextFollowUpTime))} className={classes.actionButton} onClick={() => handle_call_action_submit()} variant="outlined">
                    Submit
                  </Button>
                }

                {
                  callAction == 'sentToManager' &&
                  <Button disabled={!remarks} className={classes.filterButton} onClick={() => handle_send_to_manager()} variant="outlined">
                    Submit
                  </Button>
                }
              </DialogActions>
            </Dialog>
          </>
      }

      {
         userDetails?.roles?.find(
          role =>
            role.name === ROLENAME.TeleCallerAssistantManager
          ) &&
          <>

            <div className={classes.screenTabsDiv}>
              <Button disabled={false} className={classes.screenTabs} variant="outlined" onClick={() => handle_tab_selection('FollowUpSelfForTeam')} >
                Follow-Up
              </Button>
              {/* <Button disabled={false} className={classes.screenTabs} variant="outlined" onClick={() => handle_tab_selection('FollowUpMarketingForTeam')} >
                Follow-Up (Marketing)
              </Button> */}
              <Button className={classes.screenTabs} variant="outlined" onClick={()=>handle_tab_selection('Junk')} >
                Junk
              </Button>
              <Button className={classes.screenTabs} variant="outlined" onClick={()=>handle_tab_selection('ApprovalRequests')} >
                Approval Requests
              </Button>
            </div>

            <Dialog
              open={showReAssignDialog}
              fullWidth
              PaperComponent={PaperComponent}
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
            >
              <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px' }}>
                <IconButton onClick={() => handle_close_call_reAssign_dialog()} size="small">
                  <Close />
                </IconButton>
              </div>
              {/* <DialogTitle id="form-dialog-title" style={{ margin: "auto" }}>
                Please fill the details
              </DialogTitle> */}
              
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: '10px' }}>
                <TextField
                  select
                  labelId="demo-simple-select-label1"
                  id="demo-simple-select1"
                  value={selectedUserToReAssign}
                  label="Select User"
                  name="user_name"
                  onChange={(e) => handle_user_selection(e)}
                  variant="outlined"
                  style={{width: '50%'}}
                  size="small"
                  >
                  {reAssignUsers.map((el) =>(
                    <MenuItem value={el}>{el.name}</MenuItem>
                  ))}
                  </TextField>
                  <TextField
                    id="remarksforAM"
                    name="remarks"
                    type="text"
                    variant="outlined"
                    placeholder="Remarks"
                    onChange={(e, v) => handle_remarks(e, v)}
                    value={remarks}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    // className={classes.ref_id_from_bank_field}
                    style={{ width: '400px' }}
                  />
                </div>
              <DialogActions>
                <Button className={classes.actionButton} onClick={() => handle_re_assign_user_submit_click()} variant="outlined">
                  Submit
                </Button>
              </DialogActions>
            </Dialog>
          </>
      }

      {
        selectedTab == 'FollowUpSelfForTeam' &&
        <>
          <TableContainer component={Paper}>
            <Table className="table table-responsive table-bordered" aria-label="sticky table">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell className={classes.tableCell}>S.No</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Client Phone Number</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Last Call Date</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Follow-Up Count</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Last Remarks</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Current Owner</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Action</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {followUpSelfForTeamData.map((row, i) => {
                  return (
                    <StyledTableRow key={i + 1}>
                      <StyledTableCell style={{textAlign:"center" }}>{i + 1}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.client_phone_number ? row.client_phone_number : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.last_call_activity ? moment(row.last_call_activity).format('DD-MM-YYYY') : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.follow_up_count ? row.follow_up_count : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.last_remarks ? row.last_remarks : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.assigned_to?.name ? row.assigned_to.name : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>
                        <Button disabled={false} className={classes.actionButton} variant="outlined" onClick={() => handle_re_assign_click(row)} >
                          Re-assign
                        </Button>
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </Table>  
          </TableContainer>
        </>
      }

      {
        selectedTab == 'FollowUpMarketingForTeam' &&
        <>
          <TableContainer component={Paper}>
            <Table className="table table-responsive table-bordered" aria-label="sticky table">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell className={classes.tableCell}>S.No</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Client Phone Number</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Last Call Date</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Follow-Up Count</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Last Remarks</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Current Owner</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Action</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {followUpMarketingForTeamData.map((row, i) => {
                  return (
                    <StyledTableRow key={i + 1}>
                      <StyledTableCell style={{textAlign:"center" }}>{i + 1}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.client_phone_number ? row.client_phone_number : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.last_call_date ? row.last_call_date : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.follow_up_count ? row.follow_up_count : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.last_remarks ? row.last_remarks : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.assigned_to?.name ? row.assigned_to.name : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>
                        <Button disabled={false} className={classes.actionButton} variant="outlined" onClick={() => handle_re_assign_click(row)} >
                          Re-assign
                        </Button>
                      </StyledTableCell>

                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </Table>  
          </TableContainer>
        </>
      }

      {
        selectedTab == 'Junk' &&
        <>
          <TableContainer component={Paper}>
            <Table className="table table-responsive table-bordered" aria-label="sticky table">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell className={classes.tableCell}>S.No</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Client Phone Number</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Last Call Date</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Follow-Up Count</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Last Remarks</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Requested By</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Attachment</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Action</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {callCenterJunkLeads.map((row, i) => {
                  return (
                    <StyledTableRow key={i + 1}>
                      <StyledTableCell style={{textAlign:"center" }}>{i + 1}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.client_phone_number ? row.client_phone_number : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.last_call_activity ? row.last_call_activity : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.follow_up_count ? row.follow_up_count : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.last_remarks ? row.last_remarks : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.requested_by?.name ? row.requested_by.name : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        {row.junk_lead_attachment?.length ? <Button variant="outlined" className={classes.downloadButton} onClick={() => window.open(row.junk_lead_attachment[row.junk_lead_attachment.length - 1])}><DownloadOutlined /></Button> : 'NA'}
                      </StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>
                        <Button disabled={false} className={classes.actionButton} variant="outlined" onClick={() => handle_approve_junk_click(row)} >
                          Approve
                        </Button>
                        <Button disabled={false} className={classes.actionButton} variant="outlined" onClick={() => handle_re_assign_click(row)} >
                          Re-assign
                        </Button>
                      </StyledTableCell>

                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </Table>  
          </TableContainer>

          <Dialog
              open={showJunkLeadApprovalDialog}
              fullWidth
              PaperComponent={PaperComponent}
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
            >
              <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px' }}>
                <IconButton onClick={() => handle_close_junk_lead_approval_dialog()} size="small">
                  <Close />
                </IconButton>
              </div>
              {/* <DialogTitle id="form-dialog-title" style={{ margin: "auto" }}>
                Please fill the details
              </DialogTitle> */}
              
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: '10px' }}>
                  <TextField
                    id="remarksForJunkLeadApproval"
                    name="remarks"
                    type="text"
                    variant="outlined"
                    placeholder="Remarks"
                    onChange={(e, v) => setRemarks(e.target.value)}
                    value={remarks}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    // className={classes.ref_id_from_bank_field}
                    style={{ width: '400px' }}
                  />
                </div>
              <DialogActions>
                <Button className={classes.actionButton} onClick={() => handle_approve_junk_lead_submit()} variant="outlined">
                  Submit
                </Button>
              </DialogActions>
            </Dialog>
        </>
      }

      {
        selectedTab == 'ApprovalRequests' &&
        <>
          Table for Leads
          <TableContainer component={Paper}>
            <Table className="table table-responsive table-bordered" aria-label="sticky table">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell className={classes.tableCell}>S.No</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Lead No</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Customer No</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Lead Creation Date</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Lead Created By</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Call Recording</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Action</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {leadsForApproval.map((row, i) => {
                  return (
                    <StyledTableRow key={i + 1}>
                      <StyledTableCell style={{textAlign:"center" }}>{i + 1}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.lead_no ? row.lead_no : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.customer_no ? row.customer_no : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.lead_creation_date ? moment(row.lead_creation_date).format('DD-MM-YYYY') : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.lead_created_by ? row.lead_created_by : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.recording_url ? row.recording_url : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>
                        <Button disabled={false} className={classes.actionButton} variant="outlined" onClick={() => handle_verify_lead(row)} >
                          Verify
                        </Button>
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </Table>  
          </TableContainer>
          <br />
          <br />

          Table for Tickets
          <TableContainer component={Paper}>
            <Table className="table table-responsive table-bordered" aria-label="sticky table">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell className={classes.tableCell}>S.No</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Ticket ID</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Customer No</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Ticket Creation Date</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Ticket Created By</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Call Recording</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Category</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Assigned To</StyledTableCell>
                  <StyledTableCell className={classes.tableCell}>Verify and Re-assign</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {ticketsForApproval.map((row, i) => {
                  return (
                    <StyledTableRow key={i + 1}>
                      <StyledTableCell style={{textAlign:"center" }}>{i + 1}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.ticket_id ? row.ticket_id : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.customer_no ? row.customer_no : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.creation_date ? moment(row.creation_date).format('DD-MM-YYYY') : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.created_by ? row.created_by : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.recording_url ? row.recording_url : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.category ? row.category : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>{row.assigned_to ? row.assigned_to : 'NA'}</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }}>
                        <Button disabled={false} className={classes.actionButton} variant="outlined" onClick={() => handle_verify_and_reassign_ticket(row)} >
                          Proceed
                        </Button>
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </Table>  
          </TableContainer>

          <Dialog
              open={showLeadApprovalDialog}
              fullWidth
              PaperComponent={PaperComponent}
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
            >
              <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px' }}>
                <IconButton onClick={() => handle_close_lead_approval_dialog()} size="small">
                  <Close />
                </IconButton>
              </div>
              
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: '10px' }}>
                  <TextField
                    id="remarksForLeadApproval"
                    name="remarks"
                    type="text"
                    variant="outlined"
                    placeholder="Remarks"
                    onChange={(e, v) => handle_lead_approval_remarks(e, v)}
                    value={leadApprovalRemarks}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    // className={classes.ref_id_from_bank_field}
                    style={{ width: '400px' }}
                  />
                </div>
              <DialogActions>
                <Button disabled={!leadApprovalRemarks} className={classes.actionButton} onClick={() => handle_verify_lead_approval()} variant="outlined">
                  Submit
                </Button>
              </DialogActions>
              </Dialog>

              <Dialog
              open={showLeadDetailsDialog}
              fullWidth
              PaperComponent={PaperComponent}
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
              >
                <DialogTitle id="form-dialog-title">
                    Lead Details
                </DialogTitle>
                <Divider />
                <DialogContent>
                  <DialogContentText id="alert-dialog-slide-description" style={{ display: "flex", flexDirection: "column" }}>
                    <TextField
                    label="Lead No: "
                    size="small"
                    value={currentLeadDetails.lead_no}
                    style={{ marginBottom: 20, marginTop: 20 }}
                    name="lead_no"
                    onChange={handle_Lead_details_change}
                    variant="outlined"
                    disabled={true}
                    />
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                      <TextField
                      label="Customer Name"
                      size="small"
                      value={currentLeadDetails.customer_name}
                      name="customer_name"
                      onChange={handle_Lead_details_change}
                      variant="outlined"
                      disabled={!isEditing.customer_name}
                      style={{ flex: 9 }}
                      />
                      {!isDisabled && (
                      <button
                        onClick={() => toggleEdit('customer_name')}
                        className="p-1 rounded hover:bg-gray-100 transition-colors"
                        style={{ flex: 1 }}
                      >
                        {isEditing.customer_name ? (
                          <CheckIcon className="w-5 h-5 text-green-600" />
                        ) : (
                          <EditIcon className="w-5 h-5 text-gray-600" />
                        )}
                      </button>
                      )}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                      <TextField
                      label="Contact No."
                      size="small"
                      type="number"
                      value={currentLeadDetails.customer_no}
                      name="customer_no"
                      onChange={handle_Lead_details_change}
                      variant="outlined"
                      disabled={!isEditing.customer_no}
                      style={{ flex: 9 }}
                      />
                      {!isDisabled && (
                      <button
                        onClick={() => toggleEdit('customer_no')}
                        className="p-1 rounded hover:bg-gray-100 transition-colors"
                        style={{ flex: 1 }}
                      >
                        {isEditing.customer_no ? (
                          <CheckIcon className="w-5 h-5 text-green-600" />
                        ) : (
                          <EditIcon className="w-5 h-5 text-gray-600" />
                        )}
                      </button>
                      )}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                      <TextField
                      label="Email ID."
                      size="small"
                      value={currentLeadDetails.customer_email}
                      name="customer_email"
                      onChange={handle_Lead_details_change}
                      variant="outlined"
                      disabled={!isEditing.customer_email}
                      style={{ flex: 9 }}
                      />
                      {!isDisabled && (
                      <button
                        onClick={() => toggleEdit('customer_email')}
                        className="p-1 rounded hover:bg-gray-100 transition-colors"
                        style={{ flex: 1 }}
                      >
                        {isEditing.customer_email ? (
                          <CheckIcon className="w-5 h-5 text-green-600" />
                        ) : (
                          <EditIcon className="w-5 h-5 text-gray-600" />
                        )}
                      </button>
                      )}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                      <TextField
                      label="Address"
                      size="small"
                      value={currentLeadDetails.customer_address}
                      name="customer_address"
                      onChange={handle_Lead_details_change}
                      variant="outlined"
                      disabled={!isEditing.customer_address}
                      style={{ flex: 9 }}
                      />
                      {!isDisabled && (
                      <button
                        onClick={() => toggleEdit('customer_address')}
                        className="p-1 rounded hover:bg-gray-100 transition-colors"
                        style={{ flex: 1 }}
                      >
                        {isEditing.customer_address ? (
                          <CheckIcon className="w-5 h-5 text-green-600" />
                        ) : (
                          <EditIcon className="w-5 h-5 text-gray-600" />
                        )}
                      </button>
                      )}
                    </div>
                    <TextField
                    label="Created By" 
                    size="small"
                    value={currentLeadDetails.lead_created_by}
                    style={{ marginBottom: 20 }}
                    name="lead_created_by"
                    onChange={handle_Lead_details_change}
                    variant="outlined"
                    disabled={true}
                    />
                    <TextField
                    label="Assigned User" 
                    size="small"
                    value={currentLeadDetails.assigned_user}
                    style={{ marginBottom: 20 }}
                    name="assigned_user"
                    onChange={handle_Lead_details_change}
                    variant="outlined"
                    disabled={true}
                    />
                    <TextField
                    label="Lead Source" 
                    size="small"
                    value={currentLeadDetails.lead_source}
                    style={{ marginBottom: 20 }}
                    name="lead_source"
                    onChange={handle_Lead_details_change}
                    variant="outlined"
                    disabled={true}
                    />
                    <TextField
                    label="Audio Link" 
                    size="small"
                    value={currentLeadDetails.audio_link}
                    style={{ marginBottom: 20 }}
                    name="audio_link"
                    onChange={handle_Lead_details_change}
                    variant="outlined"
                    disabled={true}
                    />
                    <TextField
                    label="City" 
                    size="small"
                    value={currentLeadDetails.city}
                    style={{ marginBottom: 20 }}
                    name="city"
                    onChange={handle_Lead_details_change}
                    variant="outlined"
                    disabled={true}
                    />
                    <TextField
                    label="Experience Center" 
                    size="small"
                    value={currentLeadDetails.experience_center}
                    style={{ marginBottom: 20 }}
                    name="experience_center"
                    onChange={handle_Lead_details_change}
                    variant="outlined"
                    disabled={true}
                    />
                    <TextField
                    label="Scope of Work" 
                    size="small"
                    value={currentLeadDetails.scope_of_work}
                    style={{ marginBottom: 20 }}
                    name="scope_of_work"
                    onChange={handle_Lead_details_change}
                    variant="outlined"
                    disabled={true}
                    />
                    <TextField
                    label="Estimated Budget" 
                    size="small"
                    value={currentLeadDetails.estimated_budget}
                    style={{ marginBottom: 20 }}
                    name="estimated_budget"
                    onChange={handle_Lead_details_change}
                    variant="outlined"
                    disabled={true}
                    />
                    <TextField
                    label="Client wants to start interior" 
                    size="small"
                    value={currentLeadDetails.interior_to_be_start}
                    style={{ marginBottom: 20 }}
                    name="interior_to_be_start"
                    onChange={handle_Lead_details_change}
                    variant="outlined"
                    disabled={true}
                    />
                    <TextField
                    label="Is Registration Done?" 
                    size="small"
                    value={currentLeadDetails.is_registration_done}
                    style={{ marginBottom: 20 }}
                    name="is_registration_done"
                    onChange={handle_Lead_details_change}
                    variant="outlined"
                    disabled={true}
                    />
                    <TextField
                    label="Created At" 
                    size="small"
                    value={currentLeadDetails.lead_creation_date}
                    style={{ marginBottom: 20 }}
                    name="lead_creation_date"
                    onChange={handle_Lead_details_change}
                    variant="outlined"
                    disabled={true}
                    />
                    
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => handle_close_lead_edit_dialog()} variant="outlined" color="primary">
                    Cancel
                  </Button>
                  {/* <Button disabled={false} variant="contained" color="secondary" onClick={() => handle_edit_lead()} >
                    Edit
                  </Button> */}
                  <Button variant="contained" color="primary" onClick={() => setShowLeadApprovalDialog(true)}>
                    Submit
                  </Button>
                </DialogActions>
            </Dialog>

            <Dialog
              open={showTicketApprovalDialog}
              fullWidth
              PaperComponent={PaperComponent}
              aria-labelledby="alert-dialog-slide-title1"
              aria-describedby="alert-dialog-slide-description1"
            >
              {/* <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px' }}>
                <IconButton onClick={() => handle_close_ticket_approval_dialog()} size="small">
                  <Close />
                </IconButton>
              </div> */}
              
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: '10px' }}>
                  {/* <TextField
                    id="userEmail"
                    name="userEmail"
                    type="text"
                    variant="outlined"
                    placeholder="User Email ID"
                    onChange={(e, v) => setTicketReAssignUserEmail(e.target.value)}
                    value={ticketReAssignUserEmail}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    // className={classes.ref_id_from_bank_field}
                    style={{ width: '400px' }}
                  /> */}
                  <TextField
                    id="remarksForTicketApproval"
                    name="remarks"
                    type="text"
                    variant="outlined"
                    placeholder="Remarks"
                    onChange={(e, v) => setRemarks(e.target.value)}
                    value={remarks}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    // className={classes.ref_id_from_bank_field}
                    style={{ width: '400px', marginTop: '2%' }}
                  />
                </div>
              <DialogActions>
              <Button className={classes.actionButton} onClick={() => handle_close_ticket_approval_dialog()} variant="outlined">
                  Cancel
                </Button>
                <Button className={classes.actionButton} onClick={() => handle_verify_ticket_submit()} variant="outlined">
                  Submit
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              open={showTicketDetailsDialog}
              fullWidth
              PaperComponent={PaperComponent}
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
              >
                <DialogTitle id="form-dialog-title">
                    Ticket Details
                </DialogTitle>
                <Divider />
                <DialogContent>
                  <DialogContentText id="alert-dialog-slide-description" style={{ display: "flex", flexDirection: "column" }}>
                    <TextField
                    label="Lead No: "
                    size="small"
                    value={currentTicketDetails.leadNumber}
                    style={{ marginBottom: 20, marginTop: 20 }}
                    name="leadNumber"
                    onChange={handle_Ticket_details_change}
                    variant="outlined"
                    disabled={true}
                    />
                    <TextField
                    label="Ticket ID: "
                    size="small"
                    value={currentTicketDetails.ticket_id}
                    style={{ marginBottom: 20, marginTop: 20 }}
                    name="ticket_id"
                    onChange={handle_Ticket_details_change}
                    variant="outlined"
                    disabled={true}
                    />
                    <TextField
                    label="Customer Name"
                    size="small"
                    value={currentTicketDetails.customer_name}
                    style={{ marginBottom: 20 }}
                    name="customer_name"
                    onChange={handle_Ticket_details_change}
                    variant="outlined"
                    disabled={true}
                    />
                    <TextField
                    label="Contact No."
                    size="small"
                    value={currentTicketDetails.customer_no}
                    style={{ marginBottom: 20 }}
                    name="customer_no"
                    onChange={handle_Ticket_details_change}
                    variant="outlined"
                    disabled={true}
                    />
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                    {/* <TextField
                    label="Category"
                    size="small"
                    value={currentTicketDetails.category}
                    name="category"
                    onChange={handle_Ticket_details_change}
                    variant="outlined"
                    disabled={!isEditing.category}
                    style={{ flex: 9 }}
                    /> */}
                    <TextField
                      select
                      label="Category"
                      labelId="demo-simple-select-label1"
                      id="demo-simple-select1"
                      size="small"
                      value={selectedTicketCategory}
                      name="category"
                      onChange={(e) => handle_ticket_category_selection(e)}
                      variant="outlined"
                      disabled={!isEditing.category}
                      style={{ flex: 9 }}
                    >
                    {ticketCategories.map((el) =>(
                      <MenuItem value={el}>{el.value}</MenuItem>
                    ))}
                    </TextField>
                    {!isDisabled && (
                    <button
                      onClick={() => toggleEdit('category')}
                      className="p-1 rounded hover:bg-gray-100 transition-colors"
                      style={{ flex: 1 }}
                    >
                      {isEditing.category ? (
                        <CheckIcon className="w-5 h-5 text-green-600" />
                      ) : (
                        <EditIcon className="w-5 h-5 text-gray-600" />
                      )}
                    </button>
                    )}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                    <TextField
                    label="Assigned User"
                    size="small"
                    value={currentTicketDetails.assigned_to}
                    name="assigned_to"
                    onChange={handle_Ticket_details_change}
                    variant="outlined"
                    disabled={!isEditing.assigned_to}
                    style={{ flex: 9 }}
                    />
                    {!isDisabled && (
                    <button
                      onClick={() => toggleEdit('assigned_to')}
                      className="p-1 rounded hover:bg-gray-100 transition-colors"
                      style={{ flex: 1 }}
                    >
                      {isEditing.assigned_to ? (
                        <CheckIcon className="w-5 h-5 text-green-600" />
                      ) : (
                        <EditIcon className="w-5 h-5 text-gray-600" />
                      )}
                    </button>
                    )}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                    <TextField
                    label="Title"
                    size="small"
                    value={currentTicketDetails.ticketTitle}
                    name="ticketTitle"
                    onChange={handle_Ticket_details_change}
                    variant="outlined"
                    disabled={!isEditing.ticketTitle}
                    style={{ flex: 9 }}
                    />
                    {!isDisabled && (
                    <button
                      onClick={() => toggleEdit('ticketTitle')}
                      className="p-1 rounded hover:bg-gray-100 transition-colors"
                      style={{ flex: 1 }}
                    >
                      {isEditing.ticketTitle ? (
                        <CheckIcon className="w-5 h-5 text-green-600" />
                      ) : (
                        <EditIcon className="w-5 h-5 text-gray-600" />
                      )}
                    </button>
                    )}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                    <TextField
                    label="Description"
                    size="small"
                    value={currentTicketDetails.ticketDescription}
                    name="ticketDescription"
                    onChange={handle_Ticket_details_change}
                    variant="outlined"
                    disabled={!isEditing.ticketDescription}
                    style={{ flex: 9 }}
                    />
                    {!isDisabled && (
                    <button
                      onClick={() => toggleEdit('ticketDescription')}
                      className="p-1 rounded hover:bg-gray-100 transition-colors"
                      style={{ flex: 1 }}
                    >
                      {isEditing.ticketDescription ? (
                        <CheckIcon className="w-5 h-5 text-green-600" />
                      ) : (
                        <EditIcon className="w-5 h-5 text-gray-600" />
                      )}
                    </button>
                    )}
                    </div>
                    <TextField
                    label="Due Date"
                    size="small"
                    type="date"
                    value={currentTicketDetails.expectedClosureDate ? 
                      new Date(currentTicketDetails.expectedClosureDate).toISOString().split('T')[0] 
                      : ''}
                    style={{ marginBottom: 20 }}
                    name="expectedClosureDate"
                    onChange={handle_Ticket_details_change}
                    variant="outlined"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    />
                    <TextField
                    label="Follow-Up Date"
                    size="small"
                    type="date"
                    value={currentTicketDetails.followUpDate ? 
                      new Date(currentTicketDetails.followUpDate).toISOString().split('T')[0] 
                      : ''}
                    style={{ marginBottom: 20 }}
                    name="followUpDate"
                    onChange={handle_Ticket_details_change}
                    variant="outlined"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    />
                    <TextField
                    label="Created By" 
                    size="small"
                    value={currentTicketDetails.created_by}
                    style={{ marginBottom: 20 }}
                    name="created_by"
                    onChange={handle_Ticket_details_change}
                    variant="outlined"
                    disabled={true}
                    />
                    <TextField
                    label="Created At" 
                    size="small"
                    value={currentTicketDetails.creation_date}
                    style={{ marginBottom: 20 }}
                    name="creation_date"
                    onChange={handle_Ticket_details_change}
                    variant="outlined"
                    disabled={true}
                    />
                    
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => handle_close_ticket_edit_dialog()} variant="outlined" color="primary">
                    Cancel
                  </Button>
                  {/* <Button disabled={false} variant="contained" color="secondary" onClick={() => handle_edit_ticket()} >
                    Edit
                  </Button> */}
                  <Button variant="contained" color="primary" onClick={() => setShowTicketApprovalDialog(true)}>
                    Submit
                  </Button>
                </DialogActions>
            </Dialog>
        </>
      }

      <TableContainer component={Paper} className={classes.tableContainerFixed}>
        <Table className="table table-responsive table-bordered" aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableCellHead}>Title</TableCell>
              <TableCell className={classes.tableCellHead}>Count</TableCell>
              <TableCell className={classes.tableCellHead}>Duration</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dashboardTableOneData.map((row, i) => (
              <TableRow key={i + 1}>
               {row.title == 'Total' ?
                <>
                  <TableCell style={{fontWeight: 'bold'}} className={classes.tableCellNew}>{row.title ? row.title : 'NA'}</TableCell>
                  <TableCell
                  className={classes.tableCellNew}
                  style={{ textDecoration: 'underline', cursor: 'pointer', fontWeight: 'bold' }}
                  onClick={() => handleCellClick(row)}
                  >
                    {row.data ? row.data.length : 'NA'}
                  </TableCell>
                  <TableCell
                  className={classes.tableCellNew}
                  style={{ textDecoration: 'underline', cursor: 'pointer', fontWeight: 'bold' }}
                  onClick={() => handleCellClick(row)}
                  >
                    {row.sum_of_duration ? row.sum_of_duration : 'NA'}
                  </TableCell>
                </> :
                <>
                  <TableCell className={classes.tableCellNew}>{row.title ? row.title : 'NA'}</TableCell>
                  <TableCell
                  className={classes.tableCellNew}
                  style={{ textDecoration: 'underline', cursor: 'pointer' }}
                  onClick={() => handleCellClick(row)}
                  >
                    {row.data ? row.data.length : 'NA'}
                  </TableCell>
                  <TableCell
                  className={classes.tableCellNew}
                  style={{ textDecoration: 'underline', cursor: 'pointer' }}
                  onClick={() => handleCellClick(row)}
                  >
                    {row.sum_of_duration ? row.sum_of_duration : 'NA'}
                  </TableCell>
                  </>}
              </TableRow>
            ))}
            <TableRow style={{height: 20}}>
              <TableCell className={classes.tableCellNew}>{''}</TableCell>
              <TableCell className={classes.tableCellNew}>{''}</TableCell>
              <TableCell className={classes.tableCellNew}>{''}</TableCell>
            </TableRow>
              {dashboardTableTwoData.map((row, i) => (
                <TableRow key={i + 1}>
                  {row.title == 'Total' ?
                  <>
                    <TableCell style={{fontWeight: 'bold'}} className={classes.tableCellNew}>{row.title ? row.title : 'NA'}</TableCell>
                    <TableCell
                    className={classes.tableCellNew}
                    style={{ textDecoration: 'underline', cursor: 'pointer', fontWeight: 'bold' }}
                    onClick={() => handleCellClick(row)}
                    >
                      {row.data ? row.data.length : 'NA'}
                    </TableCell>
                    <TableCell
                    className={classes.tableCellNew}
                    style={{ textDecoration: 'underline', cursor: 'pointer', fontWeight: 'bold' }}
                    onClick={() => handleCellClick(row)}
                    >
                      {row.sum_of_duration ? row.sum_of_duration : 'NA'}
                    </TableCell>
                  </> :
                  <>
                    <TableCell className={classes.tableCellNew}>{row.title ? row.title : 'NA'}</TableCell>
                    <TableCell
                    className={classes.tableCellNew}
                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                    onClick={() => handleCellClick(row)}
                    >
                      {row.data ? row.data.length : 'NA'}
                    </TableCell>
                    <TableCell
                    className={classes.tableCellNew}
                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                    onClick={() => handleCellClick(row)}
                    >
                      {row.sum_of_duration ? row.sum_of_duration : 'NA'}
                    </TableCell>
                  </>}
                </TableRow>
              ))}
            </TableBody>
          </Table>
      </TableContainer>

      <Dialog open={dashboardClickedValue !== ''} onClose={() => {setDashboardClickedValue(''); setDashboardDetailedData([])}} aria-labelledby="form-dialog-title" fullWidth maxWidth='lg' style={{padding:"10rem 10rem 10rem 10rem"}}>
        <DialogTitle id="form-dialog-title" style={{ textAlign: "center" }}>
          Detailed View - {`${dashboardClickedValue}`}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {dashboardClickedValue == 'TotalLeadsCreated' &&
                  <Table className={classes.table} size="small" aria-label="customized table">
                    <StyledTableRow>
                        <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">S.No.</StyledTableCell>
                        <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Lead No</StyledTableCell>
                        <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Client Name</StyledTableCell>
                        <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Client Contact No</StyledTableCell>
                        <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Unique Lead No</StyledTableCell>
                        <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Lead Created By</StyledTableCell>
                        <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Call Date</StyledTableCell>
                        <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Call Time</StyledTableCell>
                        <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Call Duration</StyledTableCell>
                        <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Call Recording</StyledTableCell>
                  </StyledTableRow>
                <TableBody>
                  { dashboardDetailedData.map((row, i) => {
                      return (
                          <StyledTableRow key={i + 1}>
                              <StyledTableCell style={{textAlign:"center" }}>{i + 1}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.lead_no ? row.lead_no : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.customerId?.name ? row.customerId.name : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.customerId.contact_no ? row.customerId.contact_no : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.uniqueLeadNumber ? row.uniqueLeadNumber : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.createdBy?.name ? row.createdBy.name : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_date ? moment(row.call_date).format('DD-MM-YYYY') : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_time ? row.call_time : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_duration ? row.call_duration : 'NA'}</StyledTableCell>
                              {row.recording_url ?
                              <StyledTableCell style={{textAlign:"center" }} onClick={() => window.open(row.recording_url)}>
                                <a
                                href={row.recording_url} 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                style={{ color: 'blue', textDecoration: 'none' }}
                                >
                                  <span 
                                    style={{ textDecoration: 'none' }}
                                    onMouseOver={e => e.currentTarget.style.color = 'red'}
                                    onMouseOut={e => e.currentTarget.style.color = 'inherit'}
                                  >
                                    Click to Download
                                  </span>
                                </a>
                              </StyledTableCell> : <StyledTableCell style={{textAlign:"center" }}>NA</StyledTableCell>}
                          </StyledTableRow>
                      );
                  })}
                </TableBody>
              </Table>
              }
              { dashboardClickedValue == 'TotalTicketsCreated' &&
                  <Table className={classes.table} size="small" aria-label="customized table">
                    <StyledTableRow>
                        <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">S.No.</StyledTableCell>
                        <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Unique Ticket No</StyledTableCell>
                        <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Lead No</StyledTableCell>
                        <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Unique Lead No</StyledTableCell>
                        <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Client Name</StyledTableCell>
                        <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Client Contact No</StyledTableCell>
                        <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Created By</StyledTableCell>
                        <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Call Date</StyledTableCell>
                        <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Call Time</StyledTableCell>
                        <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Call Duration</StyledTableCell>
                        <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Call Recording</StyledTableCell>
                    </StyledTableRow>
                    <TableBody>
                      {dashboardDetailedData.map((row, i) => {
                          return (
                              <StyledTableRow key={i + 1}>
                                  <StyledTableCell style={{textAlign:"center" }}>{i + 1}</StyledTableCell>
                                  <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.uniqueTicketNo ? row.uniqueTicketNo : 'NA'}</StyledTableCell>
                                  <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.leadNumber ? row.leadNumber : 'NA'}</StyledTableCell>
                                  <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.uniqueLeadNumber ? row.uniqueLeadNumber : 'NA'}</StyledTableCell>
                                  <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.customerId?.name ? row.customerId.name : 'NA'}</StyledTableCell>
                                  <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.customerId.contact_no ? row.customerId.contact_no : 'NA'}</StyledTableCell>
                                  <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.ticketCreatedBy?.name ? row.ticketCreatedBy.name : 'NA'}</StyledTableCell>
                                  <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_date ? moment(row.call_date).format('DD-MM-YYYY') : 'NA'}</StyledTableCell>
                                  <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_time ? row.call_time : 'NA'}</StyledTableCell>
                                  <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_duration ? row.call_duration : 'NA'}</StyledTableCell>
                                  {row.recording_url ?
                                  <StyledTableCell style={{textAlign:"center" }} onClick={() => window.open(row.recording_url)}>
                                    <a
                                    href={row.recording_url} 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    style={{ color: 'blue', textDecoration: 'none' }}
                                    >
                                      <span 
                                        style={{ textDecoration: 'none' }}
                                        onMouseOver={e => e.currentTarget.style.color = 'red'}
                                        onMouseOut={e => e.currentTarget.style.color = 'inherit'}
                                      >
                                        Click to Download
                                      </span>
                                    </a>
                                    </StyledTableCell> : <StyledTableCell style={{textAlign:"center" }}>NA</StyledTableCell>}
                              </StyledTableRow>
                          );
                      })}
                    </TableBody>
                  </Table>
                }

              {dashboardClickedValue == 'CallsMovedToJunk' &&
                  <Table className={classes.table} size="small" aria-label="customized table">
                  <StyledTableRow>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">S.No.</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Client Contact No</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Type</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Status</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Current Owner</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Created By</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Call Date</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Call Time</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Call Duration</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Call Recording</StyledTableCell>
                </StyledTableRow>
                  <TableBody>
                    {dashboardDetailedData.map((row, i) => {
                        return (
                            <StyledTableRow key={i + 1}>
                                <StyledTableCell style={{textAlign:"center" }}>{i + 1}</StyledTableCell>
                                <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.customer_no ? row.customer_no : 'NA'}</StyledTableCell>
                                <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_type ? row.call_type : 'NA'}</StyledTableCell>
                                <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_status ? row.call_status : 'NA'}</StyledTableCell>
                                <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.assigned_to?.name ? row.assigned_to.name : 'NA'}</StyledTableCell>
                                <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.created_by?.name ? row.created_by.name : 'NA'}</StyledTableCell>
                                <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_date ? moment(row.call_date).format('DD-MM-YYYY') : 'NA'}</StyledTableCell>
                                <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_time ? row.call_time : 'NA'}</StyledTableCell>
                                <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_duration ? row.call_duration : 'NA'}</StyledTableCell>
                                {row.recording_url ?
                                <StyledTableCell style={{textAlign:"center" }} onClick={() => window.open(row.recording_url)}>
                                  <a
                                  href={row.recording_url} 
                                  target="_blank" 
                                  rel="noopener noreferrer" 
                                  style={{ color: 'blue', textDecoration: 'none' }}
                                  >
                                    <span 
                                      style={{ textDecoration: 'none' }}
                                      onMouseOver={e => e.currentTarget.style.color = 'red'}
                                      onMouseOut={e => e.currentTarget.style.color = 'inherit'}
                                    >
                                      Click to Download
                                    </span>
                                  </a>
                                  </StyledTableCell> : <StyledTableCell style={{textAlign:"center" }}>NA</StyledTableCell>}
                              </StyledTableRow>
                        );
                    })}
                  </TableBody>
                </Table>
              }

              {dashboardClickedValue == 'CallsMovedToFollowUpSelf' &&
                  <Table className={classes.table} size="small" aria-label="customized table">
                  <StyledTableRow>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">S.No.</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Client Contact No</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Type</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Status</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Current Owner</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Created By</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Call Date</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Call Time</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Call Duration</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Call Recording</StyledTableCell>
                      
                  </StyledTableRow>
                  <TableBody>
                    {dashboardDetailedData.map((row, i) => {
                        return (
                            <StyledTableRow key={i + 1}>
                                <StyledTableCell style={{textAlign:"center" }}>{i + 1}</StyledTableCell>
                                <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.customer_no ? row.customer_no : 'NA'}</StyledTableCell>
                                <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_type ? row.call_type : 'NA'}</StyledTableCell>
                                <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_status ? row.call_status : 'NA'}</StyledTableCell>
                                <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.assigned_to?.name ? row.assigned_to.name : 'NA'}</StyledTableCell>
                                <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.created_by?.name ? row.created_by.name : 'NA'}</StyledTableCell>
                                <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_date ? moment(row.call_date).format('DD-MM-YYYY') : 'NA'}</StyledTableCell>
                                <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_time ? row.call_time : 'NA'}</StyledTableCell>
                                <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_duration ? row.call_duration : 'NA'}</StyledTableCell>
                                {row.recording_url ?
                                <StyledTableCell style={{textAlign:"center" }} onClick={() => window.open(row.recording_url)}>
                                  <a
                                  href={row.recording_url} 
                                  target="_blank" 
                                  rel="noopener noreferrer" 
                                  style={{ color: 'blue', textDecoration: 'none' }}
                                  >
                                    <span 
                                      style={{ textDecoration: 'none' }}
                                      onMouseOver={e => e.currentTarget.style.color = 'red'}
                                      onMouseOut={e => e.currentTarget.style.color = 'inherit'}
                                    >
                                      Click to Download
                                    </span>
                                  </a>
                                  </StyledTableCell> : <StyledTableCell style={{textAlign:"center" }}>NA</StyledTableCell>}
                              </StyledTableRow>
                        );
                    })}
                  </TableBody>
                </Table>
              }

              {dashboardClickedValue == 'TotalIncomingCalls' &&
                  <Table className={classes.table} size="small" aria-label="customized table">
                  <StyledTableRow>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">S.No.</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Client Contact No</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Type</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Status</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Date</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Time</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Duration</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Call Recording</StyledTableCell>
                      
                </StyledTableRow>
                <TableBody>
                  {dashboardDetailedData.map((row, i) => {
                      return (
                          <StyledTableRow key={i + 1}>
                              <StyledTableCell style={{textAlign:"center" }}>{i + 1}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.customer_number ? row.customer_number : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_direction ? row.call_direction : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_status ? row.call_status : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_date ? moment(row.call_date).format('DD-MM-YYYY') : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_time ? row.call_time : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_duration ? row.call_duration : 'NA'}</StyledTableCell>
                              {row.recording_url ?
                              <StyledTableCell style={{textAlign:"center" }} onClick={() => window.open(row.recording_url)}>
                                <a
                                href={row.recording_url} 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                style={{ color: 'blue', textDecoration: 'none' }}
                                >
                                  <span 
                                    style={{ textDecoration: 'none' }}
                                    onMouseOver={e => e.currentTarget.style.color = 'red'}
                                    onMouseOut={e => e.currentTarget.style.color = 'inherit'}
                                  >
                                    Click to Download
                                  </span>
                                </a>
                                </StyledTableCell> : <StyledTableCell style={{textAlign:"center" }}>NA</StyledTableCell>}
                             </StyledTableRow>
                      );
                  })}
                </TableBody>
              </Table>
              }

              {dashboardClickedValue == 'TotalOutgoingCalls' &&
                  <Table className={classes.table} size="small" aria-label="customized table">
                  <StyledTableRow>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">S.No.</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Client Contact No</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Type</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Status</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Date</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Time</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Duration</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Call Recording</StyledTableCell>
                      
                </StyledTableRow>
                <TableBody>
                  {dashboardDetailedData.map((row, i) => {
                      return (
                          <StyledTableRow key={i + 1}>
                              <StyledTableCell style={{textAlign:"center" }}>{i + 1}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.customer_number ? row.customer_number : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_direction ? row.call_direction : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_status ? row.call_status : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_date ? moment(row.call_date).format('DD-MM-YYYY') : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_time ? row.call_time : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_duration ? row.call_duration : 'NA'}</StyledTableCell>
                              {row.recording_url ?
                              <StyledTableCell style={{textAlign:"center" }} onClick={() => window.open(row.recording_url)}>
                                <a
                                href={row.recording_url} 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                style={{ color: 'blue', textDecoration: 'none' }}
                                >
                                  <span 
                                    style={{ textDecoration: 'none' }}
                                    onMouseOver={e => e.currentTarget.style.color = 'red'}
                                    onMouseOut={e => e.currentTarget.style.color = 'inherit'}
                                  >
                                    Click to Download
                                  </span>
                                </a>
                                </StyledTableCell> : <StyledTableCell style={{textAlign:"center" }}>NA</StyledTableCell>}
                            </StyledTableRow>
                      );
                  })}
                </TableBody>
                </Table>
              }

              {dashboardClickedValue == 'TotalConnectedCalls' &&
                  <Table className={classes.table} size="small" aria-label="customized table">
                  <StyledTableRow>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">S.No.</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Client Contact No</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Type</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Status</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Date</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Time</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Duration</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Call Recording</StyledTableCell>
                      
                </StyledTableRow>
                <TableBody>
                  {dashboardDetailedData.map((row, i) => {
                      return (
                          <StyledTableRow key={i + 1}>
                              <StyledTableCell style={{textAlign:"center" }}>{i + 1}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.customer_number ? row.customer_number : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_direction ? row.call_direction : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_status ? row.call_status : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_date ? moment(row.call_date).format('DD-MM-YYYY') : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_time ? row.call_time : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_duration ? row.call_duration : 'NA'}</StyledTableCell>
                              {row.recording_url ?
                              <StyledTableCell style={{textAlign:"center" }} onClick={() => window.open(row.recording_url)}>
                                <a
                                href={row.recording_url} 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                style={{ color: 'blue', textDecoration: 'none' }}
                                >
                                  <span 
                                    style={{ textDecoration: 'none' }}
                                    onMouseOver={e => e.currentTarget.style.color = 'red'}
                                    onMouseOut={e => e.currentTarget.style.color = 'inherit'}
                                  >
                                    Click to Download
                                  </span>
                                </a>
                                </StyledTableCell> : <StyledTableCell style={{textAlign:"center" }}>NA</StyledTableCell>}
                            </StyledTableRow>
                      );
                  })}
                </TableBody>
                </Table>
              }

              {dashboardClickedValue == 'TotalMissedCalls' &&
                  <Table className={classes.table} size="small" aria-label="customized table">
                  <StyledTableRow>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">S.No.</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Client Contact No</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Type</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Status</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Date</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Time</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Duration</StyledTableCell>
                      <StyledTableCell style={{textAlign:"center" }} component="th" scope="row">Call Recording</StyledTableCell>
                      
                </StyledTableRow>
                <TableBody>
                  {dashboardDetailedData.map((row, i) => {
                      return (
                          <StyledTableRow key={i + 1}>
                              <StyledTableCell style={{textAlign:"center" }}>{i + 1}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.customer_number ? row.customer_number : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_direction ? row.call_direction : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_status ? row.call_status : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_date ? moment(row.call_date).format('DD-MM-YYYY') : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_time ? row.call_time : 'NA'}</StyledTableCell>
                              <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{row.call_duration ? row.call_duration : 'NA'}</StyledTableCell>
                              {row.recording_url ?
                              <StyledTableCell style={{textAlign:"center" }} onClick={() => window.open(row.recording_url)}>
                                <a
                                href={row.recording_url} 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                style={{ color: 'blue', textDecoration: 'none' }}
                                >
                                  <span 
                                    style={{ textDecoration: 'none' }}
                                    onMouseOver={e => e.currentTarget.style.color = 'red'}
                                    onMouseOut={e => e.currentTarget.style.color = 'inherit'}
                                  >
                                    Click to Download
                                  </span>
                                </a>
                                </StyledTableCell> : <StyledTableCell style={{textAlign:"center" }}>NA</StyledTableCell>}
                            </StyledTableRow>
                      );
                  })}
                </TableBody>
                </Table>
              }
            </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
};
export default connect(null, { setLoading, setSnackInfo })(CallCenterDashboard);